module.exports = __webpack_public_path__ + "static/img/vip_privilege9.a875ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege9.png
// module id = Gf1O
// module chunks = 0